@if (show) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
  <img src="/img/loading.gif" alt="Carregando..." class="loading-gif" width="200" />
</div>
}
